import * as types from './type';


const initialState = {
    suggestedLocation: ''
};



export default function locationReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.GET_AUTOCOMPLETE_LOCATION: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          suggestedLocation: action.payload.data
        }
      } else {
        return {
          ...state,
          suggestedLocation: ''
        }
      }
    }
    default: {
      return {
        ...state
      };
    }
    
  }

}